import Slide from '@material-ui/core/Slide';
export default {
  MuiButtonBase: {
    disableRipple: true
  },
  MuiButton: {
    variant: 'contained',
    color: 'primary'
  },
  MuiCheckbox: {
    color: 'primary'
  },
  MuiCircularProgress: {
    size: 44,
    thickness: 3
  },
  MuiDialog: {
    PaperProps: {
      elevation: 0,
      square: true
    }
  },
  MuiInputLabel: {
    disableAnimation: true,
    shrink: false
  },
  MuiLink: {
    underline: 'always'
  },
  MuiListSubheader: {
    disableSticky: true
  },
  MuiPaper: {
    square: true
  },
  MuiRadio: {
    color: 'primary'
  },
  MuiSnackbar: {
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    TransitionComponent: Slide
  },
  MuiTabs: {
    textColor: 'primary',
    indicatorColor: 'primary'
  },
  MuiTextField: {
    variant: 'filled',
    color: 'primary',
    hiddenLabel: false
  }
};